import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]
  static values = { url: String, deleteUrl: String, eventsNotChosen: String }

  updateOnSale(event) {
    event.preventDefault()
    const idsArray = this.checkboxTargets.filter((event) => event.checked).map((event) => event.value)
    if (idsArray.length > 0) {
      fetch(this.urlValue,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: "POST",
          body: JSON.stringify({ eventIds: idsArray, status: "on_sale" })
        })
        .then(function (res) { console.log(res); res.json().then(data => window.location = data.path ) })
        .catch(function (res) { console.log(res) })
    } else {
      toastr && toastr.error(this.eventsNotChosenValue);
    }
  }

  updateOffSale(event) {
    event.preventDefault()
    const idsArray = this.checkboxTargets.filter((event) => event.checked).map((event) => event.value)
    if (idsArray.length > 0) {
      fetch(this.urlValue,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: "POST",
          body: JSON.stringify({ eventIds: idsArray, status: "draft"})
        })
        .then(function (res) { console.log(res); res.json().then(data => window.location = data.path ) })
        .catch(function (res) { console.log(res) })
    } else {
      toastr && toastr.error(this.eventsNotChosenValue);
    }
  }

  deleteEventsAndTourSchedules(event) {
    event.preventDefault()
    const idsArray = this.checkboxTargets.filter((event) => event.checked).map((event) => event.value)
    if (idsArray.length > 0) {
      fetch(this.deleteUrlValue,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: "DELETE",
          body: JSON.stringify({ eventIds: idsArray})
        })
        .then(function (res) { console.log(res); res.json().then(data => window.location = data.path ) })
        .catch(function (res) { console.log(res) })
    } else {
      toastr && toastr.error(this.eventsNotChosenValue);
    }
  }
}